import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/place')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/w/$workspaceSlug/venues',
      params: { workspaceSlug: params.workspaceSlug },
      replace: true,
    })
  },
})
